import { LabelSize } from './interface';

type LabelValues = {
  [key in LabelSize]: {
    fontSize: number;
    fontWeight: number;
    lineHeight: number;
    letterSpacing: number;
  };
};

const LABEL_VALUES: LabelValues = {
  l: {
    fontSize: 16,
    fontWeight: 610,
    lineHeight: 24,
    letterSpacing: 0,
  },
  m: {
    fontSize: 14,
    fontWeight: 610,
    lineHeight: 20,
    letterSpacing: 0,
  },
  s: {
    fontSize: 13,
    fontWeight: 620,
    lineHeight: 18,
    letterSpacing: 0,
  },
  xs: {
    fontSize: 11,
    fontWeight: 540,
    lineHeight: 16,
    letterSpacing: 0,
  },
};

export { LABEL_VALUES };
